import { ProductDto, ProductPriceDto } from '../../dto';
import { ProductPriceType, ProductWithoutPriceType } from '../../types';

export const adaptProductsToClient = (
  products: ProductDto[]
): ProductWithoutPriceType[] =>
  products.map((product) => ({
    productId: product.productId,
    name: product.name,
    nameTranslit: product.nameTranslit,
    isPreorder: product.isPreorder,
    rating: product.rating,
    image: product.image,
    brandId: product.brandId,
    brandName: product.brandName,
    status: product.status,
  }));

export const adaptProductsPriceToClient = (
  productsPrice: ProductPriceDto[]
): ProductPriceType[] =>
  productsPrice.map((product) => ({
    productId: product.productId,
    basePrice: product.price.basePrice,
    salePrice: product.price.salePrice,
  }));
